import { Field, getIn, useFormikContext } from 'formik';
import React from 'react';

function Input({
  errorMessage = undefined,
  name,
  label,
  type = 'text',
  placeholder = '',
  onBlur,
  autoComplete,
  hideEmptyErrorSpace = false,
}: {
  errorMessage?: string;
  name: string;
  label: string;
  type?: 'text' | 'email' | 'password' | 'number' | 'tel' | 'textarea';
  placeholder?: string;
  onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void;
  autoComplete?: string;
  hideEmptyErrorSpace?: boolean;
}): React.JSX.Element {
  const { touched, submitCount, handleBlur } = useFormikContext();
  const isTouched: boolean = !!getIn(touched, name);
  const hasError: boolean = !!errorMessage && (isTouched || submitCount > 0);

  return (
    <label htmlFor={name} className={hasError ? 'error' : 'valid'}>
      {label}

      <Field
        id={name}
        name={name}
        as={type === 'textarea' ? 'textarea' : undefined}
        type={type === 'textarea' ? undefined : type}
        className={hasError ? 'error' : 'valid'}
        aria-invalid={hasError || undefined}
        aria-describedby={`${name}-error`}
        onBlur={(e: React.FocusEvent<HTMLInputElement>): void => {
          handleBlur(e);
          onBlur?.(e);
        }}
        placeholder={placeholder}
        autoComplete={autoComplete}
      />

      {(!hideEmptyErrorSpace || hasError) && (
        <p
          id={`${name}-error`}
          className={`errorMessage ${hasError ? 'error' : 'valid'}`}
        >
          {hasError ? errorMessage : '\u00A0'}
        </p>
      )}
    </label>
  );
}

export default Input;
